import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var menuTypeVersionSchema = () => yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      () => yup.object({
        posName: yup.string().trim().required("posNameRequired"),
        kdsName: yup.string().trim().required("kdsNameRequired"),
        checkName: yup.string().trim().required("checkNameRequired"),
        onlineName: yup.string().trim().required("onlineNameRequired"),
        itemPrice: yup.number().typeError("priceRequired").required("priceRequired"),
        suggestiveOrdering: yup.boolean().required("required"),
        ingredients: yup.lazy(
          (ingredients) => yup.object(
            mapValues(
              ingredients,
              (ingredient) => yup.object({
                posName: yup.string().trim().required("posNameRequired"),
                name: yup.string().trim().required("nameRequired").test(
                  "ingredient-unique-test",
                  "ingredientNameRepeated",
                  function() {
                    const typedIngredient = ingredient;
                    const typedIngredients = ingredients;
                    for (const property in typedIngredients) {
                      if (typedIngredient.ingredientId !== typedIngredients[property].ingredientId && typedIngredient.name.trim().toLowerCase() === typedIngredients[property].name.trim().toLowerCase()) {
                        return false;
                      }
                    }
                    return true;
                  }
                )
              })
            )
          )
        ),
        modifierGroups: yup.object().test("has-modifier-group-premade", function() {
          const menuTypeVersion = this.parent;
          const allModsBehavior = menuTypeVersion.allModsBehavior;
          const premadeModifierGroup = Object.values(
            menuTypeVersion.modifierGroups
          ).find((modifierGroup) => modifierGroup.isAllMod);
          if (allModsBehavior === "premade" /* PREMADE */ && !premadeModifierGroup) {
            return this.createError({
              message: "premadeModifierGroupRequired"
            });
          }
          return true;
        }),
        suggestiveOrderingPrompt: yup.string().trim().when("suggestiveOrdering", {
          is: true,
          then: (schema) => schema.required("promptMessageRequired"),
          otherwise: (schema) => schema.notRequired()
        }),
        suggestiveOrderingItemId: yup.number().integer().when("suggestiveOrdering", {
          is: true,
          then: (schema) => schema.positive("suggestiveOrderingItemRequired"),
          otherwise: (schema) => schema.notRequired()
        })
      })
    )
  )
);
var itemSchema = (items, itemId) => yup.object().shape({
  name: yup.string().trim().required("nameRequired"),
  customId: yup.string().test("customId-unique-test", "", function(customId) {
    const trimCustomId = (customId || "").trim().toLowerCase();
    let itemName = "";
    if (!trimCustomId)
      return true;
    const isValid = Object.values(items).every((item) => {
      if (item.itemId === itemId)
        return true;
      const trimItemCustomId = (item.customId || "").trim().toLowerCase();
      if (!trimItemCustomId)
        return true;
      const isItemValid = trimItemCustomId !== trimCustomId;
      if (!isItemValid) {
        itemName = item.name;
      }
      return isItemValid;
    });
    if (!isValid) {
      return this.createError({
        message: `<<uniqueCustomIdRequired>>${itemName}`
      });
    }
    return isValid;
  }),
  menuTypeVersions: menuTypeVersionSchema()
});
var getErrorMessages = (error) => {
  const { inner } = error;
  return inner.map(({ path, message }) => ({ path, message })).reduce(
    (acc, { path, message }) => __spreadProps(__spreadValues({}, acc), {
      [path != null ? path : "_"]: message
    }),
    {}
  );
};
var getErrorDescriptionMessage = (itemErrors, menuTypes) => {
  return Object.entries(itemErrors).map(([key, value]) => {
    if (typeof value === "string")
      return i18n_config_default.t(`validations.${value}`);
    if (typeof value === "object" && key === "menuTypeVersions") {
      return "Menu Types:\n" + Object.entries(value).map(
        ([id, menuType]) => `${menuTypes[Number(id)].posName}: (${Object.values(menuType).map((mkey) => i18n_config_default.t(`validations.${mkey}`)).join(", ")})`
      ).join("\n");
    }
    return "";
  }).join(", ");
};

export { getErrorDescriptionMessage, getErrorMessages, itemSchema, menuTypeVersionSchema };
